<template>
        <td colspan="4">
            <div class="list">
                {{ myRelations.filter(r => r.roleId == relationType.id).map(r => r.name).join(' | ') }}
            </div>
        </td>
</template>

<script>
    function initData() {
        return {
            myRelations: this.relations.map(r => ({
                relationId: r.id,
                roleId: r.role_id,
                evaluatedId: r.evaluated_id,
                evaluatingId: r.evaluating_id,
                name: this.participantById[r.evaluating_id] ?
                    this.participantById[r.evaluating_id].customer.name + ' ' + this.participantById[r.evaluating_id].customer.lastname
                    : '(Vymazaný účastník)'
            }))
        };
    }

    export default {
        props: ["relationType" , "relations",  "participantById"],
        data: function() {
            return initData.bind(this)();
        },
    }
</script>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackViewRelations.vue